import React, { useMemo } from "react";
import classNames from "classnames";

const Card = ({ className, children, ...rest }) => {
    const classes = useMemo(() => {
        return (
            classNames({
                "": true,
            }) +
      " " +
      className
        );
    }, [className]);

    return (
        <div className={classes} {...rest}>
            {children}
        </div>
    );
};

export default Card;
